export default __webpack_public_path__ + "static/media/pngkey.com-calvin-klein-logo-png-444371.2a392285.png";